<template>

  <div>
    <v-data-table :headers="headers"
                  :items="items"
                  :pagination.sync="pagination_"
                  :total-items="totalItems"
                  :rows-per-page-items="paginationOptions"
                  :loading="loading"
                  :no-data-text="'-'">
      <v-progress-linear slot="progress"
                         color="primary"
                         indeterminate="indeterminate"></v-progress-linear>
      <template slot="items" slot-scope="props" v-show="!loading">

        <!-- ID -->
        <td :class="$vuetify.breakpoint.name">
          <ExternalId :id="props.item.id" :path="'/match/' + props.item.id" />
        </td>

        <!-- SPORT -->
        <td :class="$vuetify.breakpoint.name">{{ getSportName(props.item.sportID) }}</td>

        <!-- DATE -->
        <td :class="$vuetify.breakpoint.name">{{ formatDate(props.item.date) }}</td>

        <!-- CLUB 1 -->
        <td class="wide-column" :class="$vuetify.breakpoint.name"><b>{{ props.item.club1Alias }}</b></td>

        <!-- TEAM 1 -->
        <td class="wide-column" :class="$vuetify.breakpoint.name" v-if="$country === 'US'">{{ props.item.team1Name }}</td>

        <!-- CLUB 2 -->
        <td class="wide-column" :class="$vuetify.breakpoint.name"><b>{{ props.item.club2Alias }}</b></td>

        <!-- TEAM 2 -->
        <td class="wide-column" :class="$vuetify.breakpoint.name" v-if="$country === 'US'">{{ props.item.team2Name }}</td>

        <!-- NB VIDEOS -->
        <!-- <td class="text-center" :class="$vuetify.breakpoint.name">{{ props.item.videoCount || 0 }}</td> -->

        <!-- COMPETITION -->
        <td class="wide-column" :class="$vuetify.breakpoint.name">{{ props.item.competitionName }}</td>

        <!-- CATEGORY -->
        <td :class="$vuetify.breakpoint.name">{{ props.item.categoryName || '-' }}</td>

        <!-- PLACE -->
        <td class="wide-column" :class="$vuetify.breakpoint.name">{{ props.item.placeName }}</td>

        <!-- BUTTONS -->
        <TableButtons :ref="`tableButtons-${props.item.id}`"
                      :item="props.item"
                      :index="props.index"
                      @edit="edit"
                      @del="del"
                      @suspend="suspend"
                      @unsuspend="unsuspend"
                      @reprocess="reprocess"
                      @transfer="transfer"
                      @privatize="privatize"/>

      </template>
    </v-data-table>
  </div>

</template>

<script>

import { getSportInfos } from '../../helpers/get-sport-infos'

import TableButtons from './TableButtons'
import ExternalId from '../tables/ExternalId.vue'

export default {
  name: 'Table',
  components: {
    TableButtons,
    ExternalId
  },
  props: [
    'headers',
    'items',
    'pagination',
    'paginationOptions',
    'totalItems',
    'loading'
  ],
  methods: {
    getSportName (sportid) {
      return getSportInfos({id: sportid}).names['default']
    },
    formatDate (date) {
      return new Date(date).toLocaleString(`${this.$localeRegion}-${this.$country}`)
    },
    edit (index) {
      this.$emit('edit', index)
    },
    del (item) {
      this.$emit('del', item)
    },
    suspend (item) {
      this.$emit('suspend', item)
    },
    unsuspend (item) {
      this.$emit('unsuspend', item)
    },
    reprocess (item) {
      this.$emit('reprocess', item)
    },
    transfer (frommatch, tomatch, fromAuthors) {
      this.$emit('transfer', frommatch, tomatch, fromAuthors)
    },
    closeTransfer (id) {
      this.$refs[`tableButtons-${id}`].cancelTransfer()
    },
    privatize (match, fromAuthors) {
      this.$emit('privatize', match, fromAuthors)
    },
    closePrivatization (id) {
      this.$refs[`tableButtons-${id}`].cancelPrivatization()
    }
  },
  computed: {
    pagination_: {
      get () {
        return this.pagination
      },
      set (v) {
        window.scrollTo(0, 0)
        this.$emit('paginationUpdate', v)
      }
    }
  }
}

</script>

<style lang="scss" scoped>

  td {
    &.xs {
      font-size: 11px !important;
      padding: 0 6px !important;
    }
  }

  .wide-column {
    min-width: 200px;
  }

  .text-center {
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/matches/Table.vue